import React from 'react'
import { Info } from '../NewIcons'
import Tooltip from '../Tooltip/Tooltip'

const DatatableNonResponsive = ({ cols, children }) => {
  return (
    <div className="datatablenonresponsive">
      <div className="datatablenonresponsive__head">
        {Object.values(cols).map((col, index) => (
          <DatatableNonResponsiveHeadCell key={index} col={col} />
        ))}
      </div>
      {children}
    </div>
  )
}

export const DatatableNonResponsiveHeadCell = ({ col }) => {
  // visibili sono nel desktop, quindi non gestisco i casi mobile
  return (
    <div
      onClick={col?.onClick}
      className={
        'datatablenonresponsive-headcell' +
        (col.hidden ? ' u-hidden' : '') +
        (col.align ? ' u-align-' + col.align : '')
      }
      style={
        col.width
          ? { flex: 'none', width: col.width ? col.width : null }
          : { flexGrow: col.grow ? col.grow : null }
      }
    >
      <DatatableNonResponsiveHeading label={col.label} info={col.info} />
    </div>
  )
}

export const DatatableNonResponsiveHeading = ({ label, info }) => {
  return (
    <div className="datatablenonresponsive-heading">
      <span className="datatablenonresponsive-heading__label">{label}</span>
      {info && (
        <span className="datatablenonresponsive-heading__info">
          <Tooltip label={info}>
            <Info />
          </Tooltip>
        </span>
      )}
    </div>
  )
}

export const DatatableNonResponsiveError = ({ error }) => {
  return error ? <div className="datatablenonresponsive-error">{error}</div> : <></>
}

export const DatatableNonResponsiveRow = ({ children, extra, error, even, className }) => {
  return (
    <div
      className={
        'datatablenonresponsive-row' +
        (even ? '' : ' datatablenonresponsive-row--odd') +
        (className ? ' ' + className : '')
      }
    >
      <div className="datatablenonresponsive-row__cells">{children}</div>
      {extra && <div className="datatablenonresponsive-row__extra">{extra}</div>}
      {error && (
        <div className="datatablenonresponsive-row__error">
          <DatatableNonResponsiveError error={error} />
        </div>
      )}
    </div>
  )
}

// Se non c'è il parametro col non visualizzo la cella
export const DatatableNonResponsiveCell = ({ col, error, children, className }) => {
  return col ? (
    <div
      className={
        'datatablenonresponsive-cell' +
        (col.align ? ' u-align-' + col.align : '') +
        (col.hidden ? ' u-hidden' : '') +
        (className ? ' ' + className : '')
      }
      style={
        col.width
          ? { flex: 'none', width: col.width ? col.width : null }
          : { flexGrow: col.grow ? col.grow : null }
      }
    >
      <div className="datatablenonresponsive-cell__content">{children}</div>
      {error && (
        <div className="datatablenonresponsive-cell__error">
          <DatatableNonResponsiveError error={error} />
        </div>
      )}
    </div>
  ) : (
    <></>
  )
}

export default React.memo(DatatableNonResponsive)
